/**
 * Navigate user to selected prefecture.
 */
function prefectureSelect($) {

  const target = $('select[name="js-supporter-prefecture"]');

  target.change(() => {
    const scope = target.find('option:selected').data('scope');

    window.location = `/supporter/?prefecture_id=${scope}`;
  });
}

/**
 * Toggle read more based on data-limit attribute.
 */
function readMore($) {

  const block = '.js-readmore';
  const toggler = '.js-readmore-toggle';
  const summaryClass = 'supporter__message--summary';

  // Initialize.
  $.each($(toggler), (_, elem) => {
    const active = $(elem).data('active');

    if(!active) {
      $(elem).siblings(block).addClass(summaryClass);

      const msg = $(elem).data('off');
      $(elem).text(msg);
    }
  });

  // Toggle on click.
  $(toggler).toggle(
    function() {
      $(this).siblings(block).removeClass(summaryClass);

      const msg = $(this).data('on');
      $(this).text(msg);
    },
    function() {
      $(this).siblings(block).addClass(summaryClass);

      const msg = $(this).data('off');
      $(this).text(msg);
    }
  );
}

/**
 * Runner script.
 */
function run($) {
  prefectureSelect($);
  readMore($);
}

module.exports = {
  run: run
};
